import APIClient from '../../services/APIClient';
import { makeApiCall } from '../../services/ApiService';

export default {

    createMongoQuery: (data: any) => makeApiCall({
        startCallMessage: 'API: Creating Mongo Query Data',
        successMessage: 'API: Successfully created Mongo Query Data',
        failureMessage: 'API: Creating Mongo Query Failed',
        url: '/admin/mongo-queries',
        method: APIClient.post,
        data,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.query,
    }),


    getMongoQueries: (params: any) => makeApiCall({
        startCallMessage: 'API: Fetching Mongo Queries Data',
        successMessage: 'API: Successfully Fetched Mongo Queries Data',
        failureMessage: 'API: Fetching Mongo Queries Failed',
        params,
        url: '/admin/mongo-queries',
        method: APIClient.get,
        data: null,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.queries,
    }),

    deleteMongoQueries: (data: any) => makeApiCall({
        startCallMessage: 'API: Deleting Mongo Queries',
        successMessage: 'API: Deleting Mongo Queries Success',
        failureMessage: 'API: Deleting Mongo Queries Failed',
        data,
        url: '/admin/mongo-queries/delete',
        method: APIClient.post,
        config: null,
        extractPath: (data) => data,
    }),

    editMongoQueries: (data: any) => makeApiCall({
        startCallMessage: 'API: Editing Mongo Queries',
        successMessage: 'API: Editing Mongo Queries Success',
        failureMessage: 'API: Editing Mongo Queries Failed',
        data,
        url: '/admin/mongo-queries' + (data._id ? `/${data._id}` : ''),
        method: APIClient.put,
        config: null,
        extractPath: (data) => data,
    }),

    runMongoQuery: (data: any) => makeApiCall({
        startCallMessage: 'API: Fetching mongo query data',
        successMessage: 'API: Successfully fetched Mongo Query Data',
        failureMessage: 'API: Fetching Mongo Query Failed',
        url: '/admin/mongo-queries/query',
        method: APIClient.post,
        data,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.queryResult,
    })

}
